/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jan 31 2024
 **/

// import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { has } from "lodash-es";
import { EventHandler } from "@rfice/eventhandler";
import { JotaiStore } from "@/frameworks/libraries/commons";
import { CommanderStorageAtom } from "./useCommandProducer";
import type { SubscribeParameter } from "./useCommandProducer";

export default function useCommandConsumer<R, C>(
	name: string,
	responder: R
): {
	/**
	 * Check for already subscribed
	 */
	isSubscribe(key: string): boolean;

	/**
	 * Producer 구독을 추가합니다.
	 * @param key 각 뷰를 구분하기 위한 키값
	 * @param parameter 추가 파라메터로 여기 전달된 값은 `onSubscribe`로 전달됩니다.
	 */
	subscribe: (key: string, parameter?: SubscribeParameter) => void;

	/**
	 * Producer 구독을 취소합니다.
	 * @param key 각 뷰를 구분하기 위한 키값
	 * @param parameter 추가 파라메터로 여기 전달된 값은 `onUnsubscribe`로 전달됩니다.
	 */
	unsubscribe: (key: string, parameter?: SubscribeParameter) => void;
	/**
	 * 구독 중인 Producer가 지원하는 명령
	 */
	command?: C | null;
} {
	const commanderStorage = useAtomValue(CommanderStorageAtom, { store: JotaiStore });
	const eventName = name.charAt(0).toUpperCase() + name.slice(1);

	// useEffect(() => {
	// 	console.debug("#uesCommandConsumer# commander storage updated", commanderStorage);
	// }, [commanderStorage]);

	return {
		isSubscribe(key: string) {
			if (has(commanderStorage, name)) {
				if (has(commanderStorage[name].responders, key)) {
					return true;
				}
			}
			return false;
		},
		subscribe(key: string, parameter?: SubscribeParameter) {
			EventHandler.fire(`$${eventName}::Subscribe$`, {
				key,
				...((parameter && { parameter }) || {}),
				responder
			});
		},
		unsubscribe(key: string, parameter?: SubscribeParameter) {
			EventHandler.fire(`$${eventName}::Unsubscribe$`, {
				key,
				...((parameter && { parameter }) || {})
			});
		},
		get command() {
			return (has(commanderStorage, name) && (commanderStorage[name].commander as C)) || null;
		}
	};
}
